import React from "react";

const GetStarted = () => (
  <section className="global-request-demo">
    <div className="container">
      <div className="row">
        <div className="col-lg-12"> 
          <h2>Ready to <span>Get Started?</span></h2>
        </div>
        <div className="col-lg-12"> 
          <a className="btn btn-lg request-demo" href="/request-demo" role="button">Request a Demo</a>
        </div> 
      </div>
    </div>
  </section>
);

export default GetStarted;